<template>
  <!-- 基础配置 base-->
  <span class="webMenuConfig">
    <div class="con">
      <div class="Files-top">
        <div class="ic-left">
          <span>基础配置</span>
        </div>
        <!-- <div class="btns">
          <el-button type="primary" @click="submit" style="margin-right:0px">确定修改</el-button>
        </div> -->
      </div>
      <div class="set-right">
        <div class="right-item">
          <div class="item-top">
            <span>背景图<span style="color: #ffb200;font-size: 14px;margin-left:5px;">(双击修改，单击预览)</span></span>
          </div>
          <div class="ul">
            <!-- <div class="li" v-for="(e,i) in 5" :key="i" :class="{'active':loginImgBgUrl==i}" @click="loginImgBgUrl=i"
              @dblclick="imageFn(i)">
              <img :src="'/static/unitInformation/loginBg'+i+'.png'">
              <el-image v-show="loginImgBgUrl==i" class="imaged" src="/static/unitInformation/yes.svg"
                :preview-src-list="['/static/unitInformation/loginBg'+i+'.png']">
              </el-image>
            </div> -->
            <el-carousel loop type="card" height="200px" :autoplay="false" @change="changeFn"
              style="width: 60%; margin:0 auto;overflow-x:unset;" :initial-index="loginImgBgUrl"
              indicator-position="none">
              <el-carousel-item v-for="(item,i) in 5" :key="item">
                <img :src="'/static/unitInformation/loginBg'+i+'.png'" style=" object-fit: cover; width: 100%; "
                  @dblclick="submit">
                <el-image v-show="loginImgBgUrl==i" class="imaged" src="/static/unitInformation/yes.svg">
                </el-image>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div class="right-item">
          <div class="item-top">
            <span>登录验证码</span>
          </div>
          <div style="padding: 20px;">
            是否开启 <el-switch v-model="value1" style="margin-left: 10px;" @change="submit"></el-switch>
          </div>
        </div>
      </div>

    </div>

    <el-dialog v-dialogDrag title="大图" :visible.sync="dialogVisible" width="80%">
      <img :src="imged" alt="" style="width: 100%;">
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </span>
</template>
<script>

  import request from "@/api/http.js";
  export default {

    data () {
      return {
        imged: '',
        dialogVisible: false,
        loginImgBgUrl: 0,//选中索引 
        loginImgBgUrl2: 0,//改变索引 
        value1: false,//验证码显示
        heights: document.getElementById('app').clientHeight-250,//屏幕高度 - 导航栏高度
        srcList: [
          '/static/unitInformation/loginBg0.png',
          '/static/unitInformation/loginBg1.png',
          '/static/unitInformation/loginBg2.png',
        ]
      };
    },


    mounted () {
      request({url: "/basicConfig/findorupdate",method: "post"}).then(res => {

        if(res.code==200) {
          this.loginImgBgUrl=parseInt(res.data.backgroundCode);
          this.value1=res.data.verificationState=="ENABLE"? true:false;
        }
      })

    },
    methods: {
      changeFn (v) {
        this.loginImgBgUrl2=v
      },
      ceshi () {
        console.log(this.$route);
      },
      imageFn (i) {
        this.imged='/static/unitInformation/loginBg'+i+'.png';
        this.dialogVisible=true;
      },
      submit () {
        var data=new FormData();
        data.append("backgroundCode",this.loginImgBgUrl2);
        data.append("verificationState",this.value1? "ENABLE":'DISABLE');
        console.log(data);
        request({url: "/basicConfig/findorupdate",method: "post",data}).then(res => {

          if(res.code==200) {
            this.loginImgBgUrl=this.loginImgBgUrl2;
            this.$message({message: '修改成功',type: 'success'});
          }
        })
      }
    }
  };
</script>

<style lang="scss" scoped>
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }

  .initialSettings {

    display: flex;
  }

  .con {
    width: 100%;
    height: 100%;
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
    overflow-y: scroll;
  }

  .top-title {
    font-size: 16px;
    border-bottom: 2px solid #E6E6E6;
    padding-bottom: 15px;
  }

  .set-right {
    .right-item {
      margin-top: 20px;
      border: 1px solid #E6E6E6;

      .item-top {
        color: #fff;
        display: flex;
        align-items: center;
        height: 44px;
        background-color: #368ED9;

        span {
          font-size: 16px;
          margin-left: 20px;
        }
      }

      .add-input {
        height: 77px;
        padding: 20px;
        border-bottom: 1px solid #E6E6E6;
        color: #1A1A1A;

        p {
          font-size: 16px;
        }

        span {
          color: #1A1A1A;

          &::before {
            content: '*';
            color: #F56C6C;
            margin-right: 4px;
          }
        }

        .caozuo {
          margin-top: 20px;
          display: flex;
          align-items: center;

        }
      }

      .inp {
        margin-top: 15px;
        width: 97%;
        //  display: flex;
        //  align-items: center;
        //  justify-content: space-between;

        .inp-title {
          font-size: 16px;
          color: #1A1A1A;
          margin: 20px;
        }

        .mycheckgroud {
          margin: 0px 20px;
        }

        /deep/.el-checkbox-group {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
        }

        /deep/.el-checkbox__input {
          position: relative;
          top: -1px;
          margin-left: 12px;
        }

        /deep/.el-checkbox__label {
          color: #1A1A1A;
          padding-left: 5px;
        }

      }

      .add-btns {
        width: 36px;
        height: 36px;
        background-color: #52A1FF;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        cursor: pointer;

        i {
          font-size: 22px;
        }
      }

      .item-check {
        display: inline-block;
        width: 2.4rem;
        height: 44px;
        display: flex;
        align-items: center;
        margin-bottom: 8px;

        i {
          margin-left: 12px;
          cursor: pointer;
          display: none;
          font-size: 20px;
          color: #999999;
        }

        &:hover i {
          display: block;
        }
      }
    }



  }

  .ul {
    overflow: hidden;
    height: 200px;
    padding: 20px;
    padding-bottom: 0;
    padding-right: 0;
  }

  .ul .li {
    width: calc(1920px/5);
    height: calc(980px/5);
    margin-bottom: 20px;
    cursor: pointer;
    position: relative;
    margin-right: 20px;
    box-sizing: border-box;
  }

  .ul .imaged {
    position: absolute;
    top: calc(50% - 30px);
    left: calc(50% - 30px);
    z-index: 2;
  }

  .ul .active {
    /* border: 3px solid #368ed9; */
    box-shadow: 0 6px 12px 0 #33333361;
  }

  .ul .active::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: .2;
  }

  .ul .li img {
    width: 100%;
    height: 100%;
  }

  .name-menu {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .webMenuConfig {
    .con {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      background-color: #fff;
      padding: 12px 20px 20px 20px;

    }

    .paging {
      display: flex;
      justify-content: flex-end;
      margin-top: 10px;
    }

    .public-flex {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .img-div {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .content-img {
      width: 32px;
      height: 32px;
      background-color: #000;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 2px;
    }

    .el-table__row--level-1 .content-img {
      background-color: transparent
    }

    .el-table__row--level-2 .content-img {
      background-color: transparent
    }



  }
</style>